module.exports = __webpack_public_path__ + "img/19.c69a3ae7.webp";